export const useContents = () => {
  const profile = useProfileStore();

  const getContentSection = (content: UserContent) => {
    if (content.type === UserContentType.UnDownloadedContent)
      return Sections.Nomad;
    if (!profile.isParent) return Sections.Revisions;
    if (content.isPlaceholder || content.memberId != null) {
      return Sections.Revisions;
    }

    return Sections.ParentForYou;
  };

  const {
    hasMultipleMember,
    isDefaultContentMemberId,
    saveDefaultContentMemberId,
  } = useContentsAssociatedMembers();

  const segmentedIds = computed<string[]>(() => {
    return all.value
      .filter((content) => content.segmented)
      .map((item) => item.id);
  });

  const all = computed<UserContent[]>(() => {
    if (!profile.contents) return [];
    const items = profile.contents.map((content, i) => {
      const baseSection = getContentSection(content);
      const multipleMember = content.memberId && hasMultipleMember(content.id);
      const isDefaultMember = multipleMember
        ? isDefaultContentMemberId(content.id, content.memberId)
        : true;
      const path = `/${baseSection}/${content.slug}`;
      const url = isDefaultMember
        ? path
        : `${path}/user?contentMemberId=${content.memberId}`;

      return {
        ...content,
        baseSection,
        index: i,
        path,
        url,
        multipleMember,
        isDefaultContentMember: isDefaultMember,
      };
    });
    return items as UserContent[];
  });

  const downloadedContents = computed(() => {
    return all.value.reduce<UserContent[]>((acc, content) => {
      if (content.type !== UserContentType.UnDownloadedContent)
        acc.push(content);
      return acc;
    }, []);
  });

  const mainContent = computed(() => {
    return all.value.find(
      (content) => content.type === UserContentType.MainContent
    );
  });

  return {
    all,
    mainContent,
    saveDefaultContentMemberId,
    downloadedContents,
    segmentedIds,
  };
};
